import React, { useEffect } from 'react';
import './cpublica.css';
import { cpublica } from '../../json/cpublica';

const CPublica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
       <div className='row'>
      <div className='col-12'>
        <h3 className='title'>Cuenta Pública</h3>
        <hr className='hr-gob' />
        </div>
      </div>
 
      <div className='row'> 
      {
        cpublica.map((cpublica, index1) => (
          <div key={index1} className='mb-3'>
            <button
              className='btn btn-outline-primary w100 text-start fs-9 fw-bold'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target={`#anio-${index1}`}
              aria-expanded='false'
              aria-controls={`anio-${index1}`}
            >
              {cpublica.anio}
            </button>

            <div className='collapse mt-2' id={`anio-${index1}`}>
              {
                cpublica.cpublicaLista.map((lista, index2) => (
                  <div key={index2} className='card my-2'>
                    <div className='card-header'>
                      <button
                        className='btn btn-link text-decoration-none text-start fs-9'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target={`#lista-${index1}-${index2}`}
                        aria-expanded='false'
                        aria-controls={`lista-${index1}-${index2}`}
                      >
                        {lista.nombre}
                      </button>
                    </div>
                    <div className='collapse' id={`lista-${index1}-${index2}`}>
                      <div className='card-body'>
                        {
                          lista.contenidocpublica.map((contenido, index3) => (
                            contenido.url && 
                              <div key={index3} className='mb-1'>   
                                <a
                                  href={contenido.url}
                                  target='_blank'
                                   className='btn btn-primary btn-armo-collapse'
                                >
                                  {contenido.nombre}
                                </a> 
                               </div>
                            
                          ))
                        }
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        ))
      }
      </div>  
    </div>
  );
};

export default CPublica;